import { CalendarDate } from '@internationalized/date';
import { TrailerStatus } from '@rematter/frontend-lib-api-client';

import { createMutationHook } from '~/shared/providers/api';

export const useCreateTrailerMutation = createMutationHook(
  'transportation.trailerCreate',
  (params: {
    status: TrailerStatus;
    licensePlate: string;
    licensePlateExpiration?: CalendarDate;
    vin?: string;
    capacity: number;
    country: string;
    state: string;
    notes?: string;
    transportationTypeId: string;
    facilityId: string;
  }) => ({
    transportationTrailerCreate: {
      __args: {
        input: {
          status: params.status,
          licensePlate: params.licensePlate,
          licensePlateExpiration: params.licensePlateExpiration?.toString(),
          vin: params.vin,
          capacity: params.capacity,
          country: params.country,
          state: params.state,
          notes: params.notes,
          transportationTypeId: params.transportationTypeId,
          facilityId: params.facilityId,
        },
      },
      id: true,
      status: true,
      licensePlate: true,
      transportationType: {
        id: true,
        name: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
